import React, { useState, useEffect } from "react";
import { Select } from "@windmill/react-ui";

import MenuServices from "services/MenuServices";

const SelectSubparent = ({
  register,
  name,
  defaultValue,
  required,
  onChange,
  label,
  selectedOptions,
  id_parent,
  ...props
}) => {
  const [allSubparent, setSubparent] = useState([]);
  useEffect(() => {
    async function fetchSubparent() {

      try {
        const response = await MenuServices.getAllSubParent(2, id_parent);


        setSubparent(response.data);
      } catch (error) {
        console.error("Error fetching category:", error);
      }
    }
   

    fetchSubparent();
  }, [id_parent]);
  //   const filteredCategories = allSubparent.filter(
  //     (category) => category.vehcilecategory === vehicleType
  //   );

  return (
    <Select
      className="border h-10 text-sm focus:outline-none block w-full bg-white-100 dark:bg-white border-transparent focus:bg-white"
      name={name}
      {...register(name, required ? { required: `${label} is required!` } : {})}
      {...props}
      value={defaultValue}
      onChange={onChange}
    >
      <option value="">Select Model</option>
      {Array.isArray(allSubparent) && allSubparent.length > 0 ? (
        allSubparent.map((category) => (
          <option
            key={category.id_sub_parent}
            value={category.id_sub_parent}
            disabled={selectedOptions?.includes(String(category.id_sub_parent))}
          >
            {category.sub_parent_name}
          </option>
        ))
      ) : (
        <option>Loading...</option>
      )}
    </Select>
  );
};

export default SelectSubparent;
